import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useLocalStorage } from './../../../../../../../utils/useLocalStorage'
import { urlPath } from '../../../../../../../utils/GlobalConstants'
const UsersListPagination = ({ total, page, updatePage, recordsPerPage, rowsPerPage }: any) => {

  const [totalPages, setTotalPages] = useState<number>(0)
  const location = useLocation()
  const { removeItem } = useLocalStorage()


  const getVisiblePages = (
    current: number,
    totalPages: number,
    windowSize = 2
  ) => {
    const pages: (number | string)[] = []

    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, i) => i)
    }
    pages.push(0)
    const start = Math.max(current - windowSize, 1)
    const end = Math.min(current + windowSize, totalPages - 2)
    if (start > 1) pages.push('...')
    for (let i = start; i <= end; i++) {
      pages.push(i)
    }
    if (end < totalPages - 2) pages.push('...')
    pages.push(totalPages - 1)
    return pages
  }
  const visiblePages = getVisiblePages(page, totalPages)
  useEffect(() => {
    if (!total || !rowsPerPage) {
      setTotalPages(0)
      return
    }

    const _totalPages = Math.ceil(total / rowsPerPage)
    setTotalPages(_totalPages)
  }, [total, rowsPerPage])

  const onRowsChange = (e: any) => {
    const value = Number(e.target.value)
    recordsPerPage(value)
    updatePage(0)
  }

  useEffect(() => {
    if (!location.pathname.includes(urlPath.tpvRecording)) {
      removeItem(urlPath.tpvRecording)
    }
    if (!location.pathname.includes(urlPath.salesChannel)) {
      removeItem(urlPath.salesChannel)
    }
  }, [location])

  const renderPageButton = (p: number, index: number) => {
    const isNumber = typeof p === 'number'
    return (
      <li
        key={`${p}-${index}`}
        className={clsx('page-item', {
          active: isNumber && p === page,
          disabled: !isNumber
        })}
      >
        <button
          type="button"
          className="page-link"
          disabled={!isNumber}
          onClick={() => isNumber && updatePage(p)}
        >
          {isNumber ? p + 1 : '…'}
        </button>
      </li>
    )
  }

  return (

    <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">

      {/* Result per page */}
      <div className="d-flex align-items-center gap-2">
        <select
          className="form-select w-100px"
          value={rowsPerPage}
          onChange={onRowsChange}
          aria-label="Rows per page"
          title="Rows per page"
        >
          <option value={10}>10</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>

      {/* Showing range */}
      <div className="text-gray-600 fw-semibold">
        {total > 0
          ? `${page * rowsPerPage + 1} - ${Math.min(
            (page + 1) * rowsPerPage,
            total
          )} of ${total}`
          : 'No entries to show'}
      </div>

      {/* Pagination */}
      <ul className="pagination mb-0">
        <li className={clsx('page-item', { disabled: page === 0 })}>
          <button
            type="button"
            className="page-link"
            aria-label="Previous page"
            onClick={() => page > 0 && updatePage(page - 1)}
          >
            <span className="previous" aria-hidden="true"></span>
          </button>
        </li>

        {visiblePages.map((p, index) => renderPageButton(p as number, index))}

        <li className={clsx('page-item', { disabled: page === totalPages - 1 })}>
          <button
            type="button"
            className="page-link"
            aria-label="Next page"
            onClick={() => page < totalPages - 1 && updatePage(page + 1)}
          >
            <span className="next" aria-hidden="true"></span>
          </button>
        </li>
      </ul>
    </div>

  )
}
export { UsersListPagination }
